import { log } from "@/helpers/console.ts";

export const splitStringByNewline = (str: string) => {
  const newline = /\r\n|\r|\n|\\n\\r|\\n/;
  return str.split(newline);
};

export function isLineEnding(str: string) {
  return isUnixLineEnding(str) || isWindowsLineEnding(str);
}

export function isWindowsLineEnding(str: string) {
  return str === "\r\n";
}

export function isUnixLineEnding(str: string) {
  return str === "\n";
}

const escapedCharacters: Record<string, string> = {
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "\t": "\\t",
  "\v": "\\v",
};

const replaceEscapedCharacters = (text: string) => {
  let escapedText = "";

  for (const character of text) {
    if (escapedCharacters[character]) {
      escapedText += escapedCharacters[character];
    } else {
      escapedText += character;
    }
  }

  return escapedText;
};

const IgnoreStrings = ["-", "+", "*", "/", "^", "£", "*", ",", "\\", "=", ":", "<", ">"];

export const processMathFragment = (text: string) => {
  let output = text;

  if (IgnoreStrings.includes(text.charAt(0))) {
    output = "\\" + text;
  }

  // Replace any triple dollar signs with a double dollar and escaped dollar
  output = output.replaceAll("$$$", "\\$$");
  output = output !== text ? output.replaceAll("$$", "") : text;

  // Identifies any math fragments with delimiters:
  // - $$ ... $$
  // - \[ ... \]
  // - \( ... \)
  // We also capture any new lines at the delimiter boundaries to
  // determine if we are working with a math block or not.
  const mathRegex = /(?:\$\$|\\\(|\\\[)(\r\n|\n)?(.+?)(\r\n|\n)?(?:\$\$|\\\)|\\])/gs;

  output = output.replaceAll(mathRegex, (_match, _startClosing, content, _endStarting) => {
    const startClosing = _startClosing ?? "";
    const endStarting = _endStarting ?? "";

    const isBlock = isLineEnding(startClosing) && isLineEnding(endStarting);

    const startDelimiterClosing = isBlock ? startClosing : replaceEscapedCharacters(startClosing);

    const startDelimiter = `$$${startDelimiterClosing}`;
    const endDelimiter = `${endStarting}$$`;

    const escapedContent = replaceEscapedCharacters(content);
    const response = `${startDelimiter}${escapedContent}${endDelimiter}`;

    log("table", {
      startDelimiter,
      endDelimiter,
      escapedContent,
      isBlock,
      startClosing,
      endStarting,
      response,
    });

    return response;
  });

  return output;
};
